import React from 'react'
import {
  Button,
  Field,
  StepsNextTrigger,
  StepsPrevTrigger,
} from '@lightspeed/unified-components-helios-theme/react'
import type { ApiCustomer } from '@vend/types'
import { CustomerInfo } from '../../../common/types'
import { SelectedCustomer } from '../../../common/SelectedCustomer'
import { CustomerSearch } from '../../../../../customer/customer-search/CustomerSearch'
import { STEPS } from '../types'
import { StepBreadcrumbs } from '../StepBreadcrumbs/StepBreadcrumbs'
import { useStep2Model } from './useStep2Model'

interface Group {
  id: string
  name: string
}

export interface Step2Props {
  onStepChange: (step: STEPS) => void
  onClose: () => void
  onAdd: (searchValue?: string) => void
  onSelect: (customer: ApiCustomer | null) => void
  onContactChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  newCustomer: CustomerInfo | null
  selectedCustomer: ApiCustomer | null
  group?: Group
}

export const Step2: React.FC<Step2Props> = props => {
  const models = useStep2Model(props)

  return (
    <div className="uc-base w-[640px] max-w-[calc(100vw-2rem)] rounded-lg bg-bg-neutral-top shadow-elevated">
      <StepBreadcrumbs step={STEPS.CUSTOMER} onStepChange={props.onStepChange}>
        <div className="px-8 pt-6">
          <h2 className="typography-heading-md text-fg-neutral-default">
            {models.title}
          </h2>
          <p className="mt-2 typography-body-sm text-fg-neutral-soft">
            {models.description}
          </p>
        </div>
        <div className="uc-base">
          <div className="px-8 py-5">
            <Field labelSlot={models.customerLabel}>
              {props.selectedCustomer ? (
                <SelectedCustomer
                  selectedCustomer={props.selectedCustomer}
                  group={props.group}
                  onContactChange={props.onContactChange}
                  onSelect={props.onSelect}
                />
              ) : (
                <CustomerSearch
                  placeholder={models.searchPlaceholder}
                  onAdd={props.onAdd}
                  onSelect={props.onSelect}
                  searchValue={models.searchValue}
                  suggestionsClassName="mark-as-unfulfilled-customer-popover"
                />
              )}
            </Field>
          </div>
        </div>
        <div className="flex justify-end gap-2 border-t border-border-neutral-soft px-8">
          <StepsPrevTrigger>
            <Button
              appearance="secondary"
              customDataAttributes={{
                container: { 'data-track': 'back-method-step' },
              }}
            >
              {models.backLabel}
            </Button>
          </StepsPrevTrigger>
          <StepsNextTrigger>
            <Button
              disabled={models.isNextDisabled}
              appearance="primary"
              customDataAttributes={{
                container: { 'data-track': 'next-details-step' },
              }}
            >
              {models.nextLabel}
            </Button>
          </StepsNextTrigger>
        </div>
      </StepBreadcrumbs>
    </div>
  )
}

Step2.displayName = 'Step2'
